module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (data.reason && !data.editing) { ;
__p += '\n    <article class="gap-explanation">\n        <div class="job-icon">\n            <div class="job-line"></div>\n            <div class="gap-icon">\n                <div></div>\n            </div>\n        </div>\n        <div class="job-content">\n            <span class="dates">' +
__e( data.start_date ) +
'&ndash;' +
__e( data.end_date ) +
'</span>\n            <p class="fs-hide">\n                ' +
__e( data.reason ) +
'\n            </p>\n        </div>\n    </article>\n';
 } else if (data.editing) { ;
__p += '\n    <article class="gap-explanation gap-editing js-no-edit">\n        <div class="job-icon">\n            <div class="job-line"></div>\n            <div class="gap-icon">\n                <div></div>\n            </div>\n        </div>\n        <div class="job-content">\n            ' +
((__t = ( $.svgIcon('trash', 'js-delete') )) == null ? '' : __t) +
'\n            <div class="dates">' +
__e( data.dates ) +
'</div>\n            <textarea\n                name="reason"\n                placeholder="Please explain what you did during this time..."\n            >' +
__e( data.reason ) +
'</textarea>\n            <a href="javascript://" class="js-explain-finish">Done</a>\n        </div>\n    </article>\n';
 } else if (data.ignore) { ;
__p += '\n    <article class="gap-ignored js-no-edit">\n        <div class="job-icon">\n            <div class="job-line"></div>\n            <div class="gap-icon">\n                <div></div>\n            </div>\n        </div>\n        <div class="job-content">\n            <em>Gap hidden</em> &mdash;\n            <a href="javascript://" class="js-explain">Click to add explanation (optional)</a>\n        </div>\n    </article>\n';
 } else { ;
__p += '\n    <article class="gap-discovery js-warning js-no-edit">\n        <div class="job-icon">\n            <div class="job-line"></div>\n            <div class="gap-icon">\n                <div></div>\n            </div>\n        </div>\n        <div class="job-content">\n            <h3>What happened between these jobs?</h3>\n            <p>' +
__e( data.dates ) +
'</p>\n            <div class="gap-discovery-buttons">\n                <a href="javascript://" class="js-ignore">Ignore</a>\n                <a href="javascript://" class="js-add-job">Add job</a>\n                <a href="javascript://" class="js-explain">Explain</a>\n            </div>\n        </div>\n    </article>\n';
 } ;
__p += '\n';

}
return __p
}